import { gql } from "@apollo/client";

export const getVideosListQuery = gql`
    query getVideosList($page: Int!, $limit: Int = 100000, $where: VideoWhereInput!) {
        listVideos(page: $page, elementsPerPage: $limit, videoFilter: $where) {
            posts {
                id
                downloadUri
                type {
                    name
                }
                image {
                    id
                    downloadThumbnail
                    downloadUri
                }
                thumbnail {
                    id
                    downloadUri
                }
                release {
                    image {
                        downloadThumbnail
                    }
                }
                track {
                    id
                    title
                    image {
                        downloadThumbnail
                    }
                    artist {
                        id
                        name
                    }
                }
            }
            meta {
                resultCount
                nodeCount
                currentPage
                totalPages
            }
        }
    }
`;

export const getReleasesVideosSelectionListQuery = gql`
    query getReleasesVideosSelectionList($releasesIds: [Int!]!) {
        listVideos(page: 0, videoFilter: { release_id: { in: $releasesIds } }) {
            posts {
                id
                isrc
                name
                release_id
                track {
                    id
                    isrc
                    title
                }
            }
            meta {
                nodeCount
            }
        }
    }
`;

export const getVideoCutsListQuery = gql`
    query getVideoCutsList($id: Int!) {
        getClipsByVideoId(videoId: $id) {
            id
            file {
                id
                file_uri
            }
            downloadUri
        }
    }
`;
